export default "__VITE_ASSET__f01906d8__"